import React from "react";
import AbstractTextInput from "./AbstractTextInput";
import Rules from "../../../../../config/rules";


class PhoneInput extends AbstractTextInput {

    label = "Téléphone";

    validators = !this.props.isOptional ? ['required', Rules.reg('phone')] : [Rules.reg('phone')];

    errorMessages = !this.props.isOptional ? [Rules.txtRequis, Rules.txtInvalidPhone] : [Rules.txtInvalidPhone];

    specs = {
        helperText: "",
        inputProps: { maxLength: 20 }
    }

    onChange = (event) => {
        this.onChangeFormater(event, 'getFormatedPhone');
    }
}

export default PhoneInput;
